var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShoufahuo = function SvgShoufahuo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.852 35.7a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13Zm33 0a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13Zm9-24a3.5 3.5 0 0 1 3.5 3.5v24a3.5 3.5 0 0 1-3.5 3.5h-1.5a.5.5 0 0 1-.5-.5 7 7 0 1 0-14 0 .5.5 0 0 1-.5.5h-12a3.5 3.5 0 0 1-3.5-3.5v-24a3.5 3.5 0 0 1 3.5-3.5h28.5Zm-36 6a3.5 3.5 0 0 1 3.5 3.5v18c0 1.301-.71 2.435-1.762 3.038a.5.5 0 0 1-.748-.407 7 7 0 0 0-13.98 0 .5.5 0 0 1-.749.407A3.499 3.499 0 0 1 3.352 39.2v-6.167c0-1.94.451-3.855 1.319-5.59l3.904-7.809a3.5 3.5 0 0 1 3.131-1.934h7.146Zm13.5 8.5a1 1 0 1 0 0 2H43.73a.5.5 0 0 1 .353.854l-1.94 1.939a1 1 0 1 0 1.415 1.414l4.5-4.5a1 1 0 0 0-.707-1.707h-15Zm-20.074-4.5a1 1 0 0 0-.894.553l-3.75 7.5a1 1 0 0 0 .894 1.447h7.324a1 1 0 0 0 1-1v-7.5a1 1 0 0 0-1-1h-3.574Zm25.28-5.707a1 1 0 0 0-1.413 0l-4.5 4.5a1 1 0 0 0 .707 1.707h15a1 1 0 0 0 0-2h-11.38a.5.5 0 0 1-.353-.854l1.94-1.939a1 1 0 0 0 0-1.414Z",
    fill: "url(#shoufahuo_svg__a)",
    stroke: "url(#shoufahuo_svg__b)",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shoufahuo_svg__a",
    x1: 30.852,
    y1: 12.2,
    x2: 30.852,
    y2: 48.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shoufahuo_svg__b",
    x1: 30.852,
    y1: 12.2,
    x2: 30.852,
    y2: 48.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })))));
};

export default SvgShoufahuo;